import dayjs from 'dayjs';
import { Button } from 'flowbite-react';
import React from 'react';
import { PiUsersFill } from 'react-icons/pi';
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom';
import { formatNumberWithSuffix } from 'shared-utils';
import { useCountdownV2 } from 'src/hooks/utils/useCountDownV2';
import { GetUIContestByIdAPIResponse } from 'types';

const UpcomingContestCard = ({ contest }: { contest: GetUIContestByIdAPIResponse['contest'] }) => {
	const navigate = useNavigate();
	const { days, hours, minutes, seconds } = useCountdownV2(contest?.startDate as Date);

	return (
		<div className="flex p-4 min-h-[160px] bg-gradient-to-br from-[#B8BAE4] to-[#594398] relative rounded-[8px] isolate border border-[#EBEBF0] dark:border-[#3F3F3F]">
			<Img src={'/assets/contestCardBg.svg'} className="rounded-[inherit] absolute h-full w-full inset-0 z-[-1]" />

			<div className="max-w-[80%] flex-1 flex flex-col">
				<h2 className="text-xl font-inter font-bold text-transparent bg-gradient-to-br bg-clip-text from-[#FDDD48] to-[#00B7C4]">
					{contest.title}
				</h2>

				<div className="flex text-[14px] text-[#F2F2F5] font-[400] items-center flex-wrap gap-1 mt-[9px] max-w-[80%] md:max-w-full">
					<span>{dayjs(contest.startDate).format('DD MMM, hh:mm a')}</span>
					{contest.totalRegistrations ? (
						<>
							<span className="text-[#F2F2F5] text-[6px] font-[400]">●</span>
							<span className="flex items-center gap-1">
								<PiUsersFill className="text-[#73DFE7] w-[16px] h-[16px]" />{' '}
								{contest?.totalRegistrations?.toLocaleString()} registered
							</span>
						</>
					) : null}
				</div>

				{dayjs().isAfter(contest.startDate) && dayjs().isBefore(contest.endDate) ? (
					<div className="mt-auto pt-[18px]">
						<div className="text-white bg-green-500 font-[700] relative rounded-[7.784px] flex gap-[7px] pb-[2px] justify-center w-full max-w-max px-2">
							<span className="animate-ping absolute inline-flex h-full w-full rounded-[7.784px] bg-green-400 opacity-75"></span>
							Live
						</div>
					</div>
				) : (
					<div className="flex flex-wrap gap-2 mt-auto pt-[18px] items-center">
						<span className="text-base font-[400] text-white">Starts in</span>
						<span className="bg-[#111E2C] rounded-[7.784px] flex gap-[7px] pb-[2px] justify-center w-full max-w-max px-2">
							{+days !== 0 ? (
								<>
									<div className="flex flex-col justify-center text-center">
										<span className="text-[17.514px] text-[#FC0] font-[500]">{days}</span>
										<span className="text-[7.784px] text-white font-[400] mt-[-5px]">{+days > 1 ? 'days' : 'day'}</span>
									</div>
									<span className="text-[17.514px] text-white font-[500]">:</span>
								</>
							) : null}
							<div className="flex flex-col justify-center text-center">
								<span className="text-[17.514px] text-[#FC0] font-[500]">{hours}</span>
								<span className="text-[7.784px] text-white font-[400] mt-[-5px]">{+hours > 1 ? 'hours' : 'hour'}</span>
							</div>
							<span className="text-[17.514px] text-white font-[500]">:</span>
							<div className="flex flex-col justify-center text-center">
								<span className="text-[17.514px] text-[#FC0] font-[500]">{minutes}</span>
								<span className="text-[7.784px] text-white font-[400] mt-[-5px]">{+minutes > 1 ? 'mins' : 'min'}</span>
							</div>
							{+days === 0 ? (
								<>
									<span className="text-[17.514px] text-white font-[500]">:</span>
									<div className="flex flex-col justify-center text-center">
										<span className="text-[17.514px] text-[#FC0] font-[500]">{seconds}</span>
										<span className="text-[7.784px] text-white font-[400] mt-[-5px]">
											{+seconds > 1 ? 'secs' : 'sec'}
										</span>
									</div>
								</>
							) : null}
						</span>
					</div>
				)}

				<div className="mt-auto pt-2">
					<Button
						size=""
						color="whiteBlue"
						className="px-[20px] py-[10px] max-h-[36px] min-w-[140px]"
						onClick={() => {
							navigate(`/contests/${contest._id}`);
						}}
					>
						Participate
					</Button>
				</div>
			</div>

			<div className="absolute bottom-[-18%] tmd:bottom-0 right-0 h-full w-full z-[-1] flex justify-center max-w-[161px] tmd:max-w-[200px] ml-auto">
				<div className="absolute text-center pt-3 mx-auto text-white">
					<p>Prizes worth</p>
					<h4 className="text-[32px] leading-[38.4px] font-[800] [text-shadow:_0px_4px_4px_rgba(0,_0,_0,_0.25)]">
						₹{formatNumberWithSuffix(contest?.totalRewardMoney)}
					</h4>
				</div>
				<Img
					src="https://masai-website-images.s3.ap-south-1.amazonaws.com/svgviewer_png_output_5_65ca944d67.png"
					className="w-full h-full object-contain"
				/>
			</div>
		</div>
	);
};

export default UpcomingContestCard;
